import { render, staticRenderFns } from "./SecondaryPasswordModal.vue?vue&type=template&id=50344eea&scoped=true&"
import script from "./SecondaryPasswordModal.vue?vue&type=script&lang=js&"
export * from "./SecondaryPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50344eea",
  null
  
)

export default component.exports